import { z } from 'zod';
import { SalesRole } from '../enums.js';
export const LoginRequest = z.object({
    email: z.string().email(),
    password: z.string().min(8),
});
export const LoginResponse = z.object({
    token: z.string(),
    expiresAt: z.string().datetime(),
    user: z.object({
        id: z.string().uuid(),
        name: z.string(),
        email: z.string().email(),
        role: SalesRole,
        tenantId: z.string().uuid(),
    }),
});
export const MeResponse = LoginResponse.shape.user;
//# sourceMappingURL=auth.js.map